import { useVehicleCount } from '@cinch-nx/search-shared'
import { FullWidthCTA } from '@cinch-nx/landing-ui-shared'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { useRouter } from 'next/router'
import { Head } from '@cinch-nx/landing-ui-shared'

import { storyblokComponents } from './data/storyblok-renderer-map'
import { SeoPageProps } from './get-static-props'
import styles from './seo-page.module.css'
import { SEOPageStoryContent } from './types/seo-page'

export const SEOPageFeature = ({ story }: SeoPageProps) => {
  const content = { ...story?.content }

  const typedContent = content as SEOPageStoryContent

  const SEO = typedContent?.['SEO']?.[0]

  const { vehicleCount } = useVehicleCount()
  const router = useRouter()
  const numberOfCars = new Intl.NumberFormat('en-GB').format(vehicleCount ?? 0)
  const { trackEvent } = useAnalytics()
  const handleClick = () => {
    trackEvent({
      eventName: `Abandoned Landing page - click search all cars button`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'button',
          label: 'browse all cars',
          action: 'footer',
        },
      },
    })
    router.push('/used-cars')
  }

  const limitedItems: { [key: string]: number } = { FaqSection: 1 }

  const wrappedComponents = typedContent.body
    .map((el) => el.component)
    .filter((el) => el !== 'FeatureSection')

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle={story?.slug ? story?.slug : 'Cinch Used Cars Article'}
        fallbackDescription={'Cinch Used Cars'}
      />
      <article className={styles.mainSection} data-testid="seo-page">
        {typedContent && (
          <StoryblokRenderer
            block={typedContent.body}
            limitedItems={limitedItems}
            componentsWithWrapper={wrappedComponents}
            components={storyblokComponents}
          />
        )}
        <FullWidthCTA
          iconName="search"
          iconGradient="galaxy"
          iconSize={41}
          title="Let’s find your next car"
          subtitle="Ready to hit the open road?"
          buttonLabel={`Search all ${numberOfCars} cars`}
          className={styles.cta}
          onButtonClick={handleClick}
          img={{
            src: 'https://a.storyblok.com/f/132543/1054x407/a30d43e649/about-us-civic.png/m/871x0',
            alt: 'Side view of a Honda Civic',
            width: 871,
            height: 336,
          }}
        />
      </article>
    </>
  )
}
